export function takeProps(keys, props) {
    let result = {};
    keys.forEach(function(key) {
        if (props[key]) result[key] = props[key];
    });
    return result;
}